import { useSessionUser } from "hooks/useSession";
import { useMemo } from "react";
import { Motion } from "components/common";
import { ENVS } from "config";

import RocketImg from "assets/images/Rocket.svg";
import { selectIsOnActivePastDueSubscription } from "store/selectors/profileSelectors";
import { IoIosWarning } from "react-icons/io";

export const UpgradePanel: React.FC = () => {
  const { session: profile, isOneTimePurchase } = useSessionUser();
  const isOnActivePastDueSubscription = selectIsOnActivePastDueSubscription(profile);
  const isFreePlan = profile?.pricing_plan_id === Number(ENVS.freePlanId);

  const daysDiff: number = useMemo(() => {
    // Use subscription end_date for trial calculations
    const trialEndDate =
      profile?.subscription?.status === "trialing" ? profile.subscription.end_date : null;

    if (!trialEndDate) return 0;

    const trialEndMs = new Date(trialEndDate).getTime();
    const nowMs = Date.now();
    const timeDiffMs = trialEndMs - nowMs;
    return Math.floor(timeDiffMs / (1000 * 3600 * 24)) + 1;
  }, [profile?.subscription?.end_date, profile?.subscription?.status]);

  const getDaysLeft = () => {
    if (daysDiff === 1) {
      return "ends tomorrow!";
    } else if (daysDiff < 1) {
      return "has ended!";
    } else {
      return `ends in ${daysDiff} days!`;
    }
  };

  const showUpgradePanel =
    isOneTimePurchase === false && (Boolean(isFreePlan) || isOnActivePastDueSubscription);

  if (!showUpgradePanel) return null;

  return (
    <Motion
      className="flex flex-row justify-between card-border bg-muted/60 h-fit w-full mt-[2em] p-[1em]"
      type={"div"}
      delayValue={0.1}
      property="y"
    >
      <div className="flex flex-row gap-[1em] max-w-[85%]">
        <div className="card-border w-fit bg-muted p-[1em] text-primary">
          {isFreePlan ? (
            <img src={RocketImg} alt="rocket" className="h-10 w-10" />
          ) : (
            <IoIosWarning className=" text-4xl" />
          )}
        </div>

        <div className="flex flex-col my-auto">
          <span className="text-regular-0 font-squada text-left">
            {isFreePlan ? "Upgrade Your Subscription" : "Update Your Billing Information"}
          </span>
          <span className="text-regular-2 text-left opacity-60">
            {isFreePlan
              ? `Your free trial ${getDaysLeft()} Upgrade now to continue without pause and take your
                projects to the next level. 
                ${
                  daysDiff < 1
                    ? "Personal projects will be unavailable until the account is upgraded"
                    : ""
                }`
              : "You have an overdue payment and we are retrying it. Update your billing details to avoid losing access."}
          </span>
        </div>
      </div>
    </Motion>
  );
};
